// extracted by mini-css-extract-plugin
export var avatarContainer = "_5d-1";
export var largeAvatarContainer = "_5d-2";
export var smallAvatarContainer = "_5d-0";